import { h, Host } from "@stencil/core";
import { configureSlider } from "../abstract-uvex-slider/configure-slider";
export class Slider {
    async componentDidLoad() {
        // init element when visibility
        this.elementObserver = new IntersectionObserver((entries, observer) => {
            if (entries[0].isIntersecting) {
                this.init();
                observer.disconnect();
            }
        }, {});
        this.elementObserver.observe(this.el);
    }
    disconnectedCallback() {
        if (this.elementObserver) {
            this.elementObserver.disconnect();
            this.elementObserver = undefined;
        }
        if (this.swiper) {
            this.swiper.destroy();
        }
    }
    init() {
        this.swiper = configureSlider(this.el, { autoplay: { delay: 5000 } });
    }
    render() {
        return h(Host, { key: '80c475c77d13a2b926e627edfd439fb980d1d72d', class: "carousel" }, h("div", { key: '64ae30373437c278a0afe4d9e9cb76d8233c80de', class: "carousel-inner" }, h("slot", { key: '6d930f53046fbdd123652c7cae748f37d60f36bf' })), h("a", { key: '994e317b9e40f998c8e6fa0f78bf29a604b8436f', class: "carousel-control carousel-control-left left", role: "button" }), h("a", { key: '9d3bac54bec181eb50d4bf0c8207a2adea1448fa', class: "carousel-control carousel-control-right right", role: "button" }), h("ol", { key: '3e2b87703fcc98b065df4d30abccf7b20f67565e', class: "carousel-indicators" }));
    }
    static get is() { return "uvex-slider"; }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=slider.js.map
